/**
 * Created by DynamicDog on 2017-03-03.
 */
import {Component, Input, Output,EventEmitter} from '@angular/core';
import {NG_VALUE_ACCESSOR} from '@angular/forms';
@Component({
    selector: 'number-spinner',
    template: `
        <div>
            <div class="spinner-button" (click)="decrease($event)">-</div><input class="spinner-edit" name="etikettCount" value="{{counterVal}}" (keydown)="onChange($event)" [(ngModel)]="counter"><div class="spinner-button" (click)="increase($event)">+</div>
        </div>
`,
    providers: [
        {provide: NG_VALUE_ACCESSOR, useExisting: NumberSpinnerComponent, multi: true}
    ],
})
export class NumberSpinnerComponent {
    counterValue: string = '1';

    @Input()
    get counter() {
        return parseInt(this.counterValue);
    }

    constructor() {

    }

    private increase(event) {
        this.counter++;
        event.stopPropagation();
    }

    private decrease() {
        if(this.counter > 1) {
            this.counter--;
        }
        event.stopPropagation();
    }

    private onChange(event) {
        if(isNaN(parseInt(event.key))) {
            event.preventDefault();
        }
    }

    @Output() counterChange = new EventEmitter();


    set counter(val) {
        this.counterValue = ''+val;
        this.counterChange.emit(this.counterValue);
    }
}


// WEBPACK FOOTER //
// ./app/print/numberspinner.component.ts